export default __webpack_public_path__ + "static/media/LAS0060.34I107152_-17545_0.eaae7d94.jpg";